import './BIToolsCard.less';

import React from 'react';
import Icon, { InfoCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useHistory } from 'react-router';
import MainCard from '../MainCard/MainCard';
import { ReactComponent as BIToolsIcon } from 'images/bi-tools-icon.svg';
import { Instance, ServerConfiguration } from 'types/cluster';
import CopyableText from 'components/CopyableText/CopyableText';

interface BIToolsCardProps {
  instance: Instance;
  serverConfigurations: ServerConfiguration[];
}

function BIToolsCard({ instance, serverConfigurations }: BIToolsCardProps) {
  let history = useHistory();

  let canUpdate = instance.clusterPolicy.clusterPolicy.includes('update');

  if (instance.sqliEnabled) {
    return (
      <MainCard
        icon={<Icon component={BIToolsIcon} />}
        title={'Connect External BI Tools'}
        subtitle={'Connection Enabled'}
        hideFooter={!canUpdate}
        footerText={'External BI tools'}
        onFooterClick={() => {
          history.push(
            `/clusters/${instance.name}?tab=configurations#cluster-external-bi-tools`,
          );
        }}
        content={
          <div className="BIToolsCard">
            <p className="BIToolsCard__hint">
              Connect to External BI tools by copying the following strings to
              the BI tools!
            </p>

            <div className="BIToolsCard__server-configuration-wrapper">
              {serverConfigurations.map(config => {
                return (
                  <div
                    key={config.name}
                    className="BIToolsCard__config-section"
                  >
                    <div className="BIToolsCard__config-section-name">
                      {config.name}
                      <Tooltip
                        placement="top"
                        title={config.description}
                        overlayClassName="full-width-tooltip"
                      >
                        <InfoCircleOutlined />
                      </Tooltip>
                    </div>
                    <CopyableText text={config.text} />
                  </div>
                );
              })}
            </div>
          </div>
        }
      />
    );
  }

  return (
    <MainCard
      icon={<Icon component={BIToolsIcon} />}
      title={'Connect External BI Tools'}
      subtitle={'Connection Disabled'}
      hideFooter={!canUpdate}
      footerText={'Connect external BI tools'}
      onFooterClick={() => {
        history.push(
          `/clusters/${instance.name}?tab=configurations#cluster-external-bi-tools`,
        );
      }}
      content={
        <div className="BIToolsCard">
          <p className="BIToolsCard__hint" style={{ marginBottom: 0 }}>
            Enabling connection allow you connect Tableau, Power BI or SQL
            client to Incorta using PostgreSQL connector.
          </p>
        </div>
      }
    />
  );
}

export default BIToolsCard;
